import { render, staticRenderFns } from "./billType.vue?vue&type=template&id=6a85ff8e&scoped=true"
import script from "./billType.vue?vue&type=script&lang=js"
export * from "./billType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a85ff8e",
  null
  
)

export default component.exports